import React from "react";
import "./Footer.css";
// Removed the unused useLanguage import
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import logo from "../assets/logo.png";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-wrapper">
          {/* Social icons with logo positioned next to Instagram */}
          <div className="social-icons">
            {/* Logo first, followed by social icons */}
            <div className="footer-logo-section">
              <img
                src={logo}
                alt="Arzei Chessed Logo"
                className="footer-logo"
              />
              <div className="registration-number">
                <span className="reg-prefix">ע״ר</span> 580799716
              </div>
            </div>
            <a
              href="https://www.instagram.com/arzei_chessed"
              className="social-icon-container"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon">
                <InstagramIcon />
              </div>
            </a>
            <a
              href="https://www.youtube.com/@arzeichessed"
              className="social-icon-container"
              aria-label="YouTube"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon">
                <YouTubeIcon />
              </div>
            </a>
            <a
              href="mailto:arzeichessed@gmail.com"
              className="social-icon-container"
              aria-label="Email"
            >
              <div className="social-icon">
                <EmailIcon />
              </div>
            </a>
            <a
              href="https://wa.me/+972544444444"
              className="social-icon-container"
              aria-label="WhatsApp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="social-icon">
                <WhatsAppIcon />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
